import React from 'react';

export function EnergyIconAFC() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 91.15 52.45">
            <defs>
                <style>
                    {`
                        .cls-1-c {
                            stroke-width: .82px;
                        }

                        .cls-1-c, .cls-2-c, .cls-3-c {
                            stroke: #231f20;
                            stroke-linecap: round;
                            stroke-linejoin: round;
                        }

                        .cls-1-c, .cls-3-c {
                            fill: none;
                        }

                        .cls-4-c {
                            font-size: 18.42px;
                        }

                        .cls-4-c, .cls-5-c {
                            fill: #231f20;
                            font-family: Calibri-Bold, Calibri;
                            font-weight: 700;
                        }

                        .cls-6-c {
                            fill: #fdb913;
                        }

                        .cls-6-c, .cls-7-c, .cls-8-c {
                            stroke-width: 0px;
                        }

                        .cls-5-c {
                            font-size: 10px;
                        }

                        .cls-2-c {
                            stroke-width: .5px;
                        }

                        .cls-2-c, .cls-8-c {
                            fill: #fff;
                        }

                        .cls-7-c {
                            fill: #fff200;
                        }

                        .cls-3-c {
                            stroke-width: 1.07px;
                        }
                    `}
                </style>
            </defs>
            <g id="C">
                <rect className="cls-8-c" x="69.5" y=".73" width="21.33" height="49" />
                <polygon className="cls-6-c" points="22.62 .77 .29 25.06 22.62 49.35 71.62 49.35 71.62 .77 22.62 .77" />
                <path
                    className="cls-1-c"
                    d="M23.1.41h67.27c.2,0,.36.16.36.36v48.58c0,.2-.16.36-.36.36H23.1c-.1,0-.2-.04-.26-.12L.5,25.3c-.13-.14-.13-.35,0-.48L22.84.52c.07-.07.16-.12.26-.12Z"
                />
                <g id="B">
                    <rect className="cls-8-c" x="69.5" y=".73" width="21.33" height="49" />
                    <polygon
                        className="cls-7-c"
                        points="22.62 .77 .29 25.06 22.62 49.35 71.62 49.35 71.62 .77 22.62 .77"
                    />
                    <path
                        className="cls-1-c"
                        d="M23.1.41h67.27c.2,0,.36.16.36.36v48.58c0,.2-.16.36-.36.36H23.1c-.1,0-.2-.04-.26-.12L.5,25.3c-.13-.14-.13-.35,0-.48L22.84.52c.07-.07.16-.12.26-.12Z"
                    />
                </g>
                <path
                    className="cls-2-c"
                    d="M52.8,34.33c0,.31,0,.57-.03.79s-.04.4-.08.56c-.03.16-.08.29-.14.4-.06.11-.15.24-.27.38-.13.14-.37.32-.73.55-.36.22-.8.44-1.32.64s-1.12.37-1.78.51c-.67.14-1.39.2-2.17.2-1.52,0-2.89-.25-4.12-.76-1.22-.51-2.27-1.27-3.12-2.27-.86-1.01-1.52-2.27-1.97-3.78-.46-1.51-.69-3.27-.69-5.27s.25-3.86.75-5.44c.5-1.58,1.21-2.91,2.11-3.99.9-1.08,1.99-1.89,3.25-2.45s2.66-.84,4.18-.84c.62,0,1.21.06,1.78.17s1.1.26,1.59.44c.49.18.92.39,1.31.62.39.23.66.44.82.6.15.17.26.31.32.42s.1.25.14.43c.03.17.06.38.08.61.02.24.03.53.03.87,0,.37-.01.69-.03.95-.02.26-.06.47-.12.63-.06.16-.13.28-.21.35s-.17.11-.27.11c-.17,0-.39-.11-.65-.32-.26-.22-.6-.46-1.02-.72-.42-.27-.92-.51-1.49-.72-.58-.22-1.27-.33-2.07-.33-.88,0-1.67.2-2.36.58-.69.39-1.28.95-1.77,1.67s-.86,1.6-1.11,2.63c-.25,1.03-.38,2.19-.38,3.47,0,1.41.13,2.63.4,3.67.27,1.03.65,1.88,1.15,2.55.5.67,1.1,1.17,1.8,1.5s1.5.49,2.38.49c.8,0,1.49-.1,2.08-.31s1.08-.43,1.5-.68c.42-.25.76-.47,1.03-.67.27-.2.48-.3.63-.3.11,0,.21.03.27.07.07.05.13.15.17.3.05.15.08.36.1.62.02.27.03.62.03,1.07Z"
                />
            </g>
            <g id="Layer_11" data-name="Layer 11">
                <g>
                    <line className="cls-3-c" x1="81.33" y1="30.37" x2="81.33" y2="20.01" />
                    <polyline className="cls-3-c" points="84.08 22.71 81.33 19.96 78.59 22.71" />
                </g>
                <text className="cls-4-c" transform="translate(76.62 45.94) scale(1 1.01)">
                    <tspan x="0" y="0">
                        F
                    </tspan>
                </text>
                <text className="cls-4-c" transform="translate(74.84 15.94) scale(1 1.01)">
                    <tspan x="0" y="0">
                        A
                    </tspan>
                </text>
                <text className="cls-5-c" transform="translate(83.5 9.24) scale(1 1.01)">
                    <tspan x="0" y="0">
                        +
                    </tspan>
                </text>
            </g>
        </svg>
    );
}
